export const es = {
  common: {
    next: 'Avanzar',
    verify: 'Verificar',
    email_placeholder: 'Ingrese su correo electrónico',
    email_invalid: 'Correo electrónico inválido',
    email_required: 'Correo electrónico es obligatorio',
    password_placeholder: 'Ingrese su contraseña',
    password_required: 'La contraseña es obligatoria',
    password: 'Contraseña',
    close: 'Cerrar',
    default_error_message:
      'Ocurrió un error inesperado. Por favor, inténtelo de nuevo.',
    male: 'Masculino',
    female: 'Femenino',
    scheduling: 'Agendar',
    unknown: 'Desconocido',
    undifferentiated: 'Indiferenciado',
    md: 'Dr.',
    payment_method: 'Método de pago',
    patient_name: 'Paciente',
    type_attendance: 'Tipo de atención',
    doctor_name: 'Médico',
    date_and_time: 'Fecha y hora',
    see_details: 'Ver detalles',
    common_connectivity_error:
      'Por favor, inténtelo de nuevo, o verifique su conexión a internet.',
    from: 'de',
    change: 'Cambiar',
    look: 'Ver',
    cancel: 'Cancelar',
    save: 'Guardar',
    confirm: 'Confirmar',
    cancel_popup_title: '¿Cancelar cita?',
    cancel_popup_description: '¿Está seguro de que desea cancelar esta cita?',
    in_person: 'Presencial',
    online: 'En línea',
    common_field_label_required: 'Campo obligatorio',
    comming: 'Próximamente',
    warning_cancelarion_refund_title: 'Cancelación (Tarjeta de crédito)',
    warning_cancelarion_refund: 'Reembolso total',
    warning_cancelarion_no_refund: 'Sin reembolso',
    hours_ahead: 'horas adelante',
    hours_behind: 'horas atrás',
    same_time: 'mismo horario',
  },

  auth: {
    forgot_password: '¿Olvidaste tu contraseña?',
    remember_me: 'Recuérdame',
    login_button: 'Iniciar sesión',
    create_account: 'Crear cuenta',
    warning_description:
      'Hemos encontrado un problema técnico al intentar completar tu registro. Por favor, inténtalo de nuevo.',
    warning_left_button: 'Ir a inicio',
    warning_right_button: 'Intentar de nuevo',
    'Incorrect username or password.': 'Correo o contraseña incorrectos.',
    success_token: 'Su código ha sido validado',
  },
  create_new_password: {
    code_resend_error:
      'Error al reenviar el código. Por favor, inténtelo de nuevo.',
    code_resent_info: 'Código reenviado con éxito al correo: {{email}}',
    email_sent_code:
      'Enviamos un código de 6 dígitos a tu correo: <strong>{{email}}</strong>',
    password_confirmation_required:
      'La confirmación de la contraseña es obligatoria',
    enter_your_new_password: 'Ingresa tu nueva contraseña',
    confirm_your_new_password: 'Confirma tu nueva contraseña',
    confirm_password: 'Confirma la contraseña',
    password_requirements_title: 'Tu contraseña debe contener:',
    has_eight_characters: 'Al menos 8 caracteres',
    has_one_number: 'Al menos 1 número',
    has_one_letter: 'Al menos 1 letra',
    btn_create_password: 'Crear contraseña',
    title_forgot_password: '¿Olvidaste tu contraseña?',
    verify_your_email: 'Verifica tu correo',
    required_code: 'El código es obligatorio',
    min_length_password: 'La contraseña debe tener al menos 8 caracteres',
    password_has_number: 'La contraseña debe contener al menos 1 número',
    password_has_letter: 'La contraseña debe contener al menos 1 letra',
    password_not_match: 'Las contraseñas no coinciden',
    title_code_verification: 'Código de verificación',
    resend_code: 'Reenviar',
    subtitle_create_new_password:
      '¡Crea una nueva contraseña para proteger tu cuenta!',
    expiration_time: 'El código expira en ',
    not_received_code: '¿No recibiste el código?',
    'Invalid verification code provided, please try again.':
      'Código de verificación no válido proporcionado, inténtelo de nuevo.',
  },
  forgot_password: {
    error_sending_email:
      'Error al enviar el correo. Por favor, inténtelo de nuevo.',
    btn_email_sent: 'Enviar correo',
    email_sent: 'Correo enviado',
    forgot_password_title: '¿Olvidaste tu contraseña?',
    forgot_password_subtitle: 'Registrar una nueva contraseña',
    forgot_description:
      'Para registrar una nueva contraseña, por favor, proporciona el correo asociado a tu cuenta.',
    resend_code_title: 'Reenviar código',
    account_validation_title: 'Validación de cuenta',
    account_validation_description:
      'Si desea validar este correo electrónico, por favor continúe. Enviaremos un correo con el código de validación de cuenta.',
  },
  signInPersonalInfo: {
    create_account_title: 'Crear nueva cuenta',
    create_account_step_1_subtitle: '¡Empecemos!\n Cuéntanos un poco sobre ti',
    create_account_name: 'Nombre',
    create_invalid_name: 'El nombre es requerido',
    create_invalid_name_less_3: 'El nombre debe tener al menos 3 caracteres',
    create_account_surname: 'Apellido',
    create_invalid_surname: 'El apellido es requerido',
    create_invalid_surname_less_3:
      'El apellido debe tener al menos 3 caracteres',
    create_account_birthdate: 'Fecha de nacimiento',
    create_invalid_birthdate: 'La fecha de nacimiento es requerida',
    create_account_email: 'Correo electrónico',
    create_invalid_email: 'El correo electrónico es requerido',
    create_account_phone: 'Teléfono',
    create_invalid_phone: 'El teléfono es requerido',
    create_less_min_phone_number:
      'El teléfono debe tener al menos {{minLength}} caracteres',
    create_invalid_country_code: 'DDI inválido',
    create_account_gender: 'Sexo biológico',
    create_account_invalid_gender: 'Sexo biológico é obrigatório',
    create_account_email_already_registered:
      '¡Correo electrónico ya registrado!',
    login_account_email_already_registered_description:
      'Este correo electrónico ya está registrado, pero aún necesita ser verificado. Confírmalo ahora o usa otro correo electrónico para continuar.',
    create_account_email_already_registered_resend_password:
      'Restablecer contraseña',
    create_account_email_already_registered_change_email:
      'Cambiar correo electrónico',
    create_account_email_already_registered_verify_email:
      'Confirmar correo electrónico',
  },
  signInAddress: {
    create_account_step_2_subtitle:
      'Tranquilo, tu información está segura con nosotros',
    create_account_zip: 'Zip code',
    create_account_invalid_zip: 'El zip code es requerido',
    create_account_invalid_zip_number: 'El código postal no es un número',
    create_account_invalid_less_min:
      'El código postal debe tener al menos 5 caracteres',
    create_account_address: 'Dirección',
    create_account_invalid_address: 'La dirección es requerida',
    create_account_city: 'Ciudad',
    create_account_invalid_city: 'La ciudad es requerida',
    create_account_state: 'Estado',
    create_account_invalid_state: 'El estado es requerido',
    create_account_complement: 'Complemento',
    create_account_zip_auto_fill_error: 'Zip code inválido',
  },
  signInPassword: {
    create_account_step_3_subtitle: 'Casi listo, es hora de la contraseña',
    create_account_password: 'Contraseña',
    create_account_confirm_password: 'Repetir contraseña',
    create_account_required_title: 'Tu contraseña debe contener:',
    create_account_length: 'Tiene 8 dígitos',
    create_account_one_number: 'Tiene al menos 1 número',
    create_account_one_letter: 'Tiene al menos 1 letra',
    create_account_allow_privacy: 'Política de privacidad',
    create_account_allow_text: 'Permitir con',
    create_account_terms_middle: 'y con el',
    create_account_terms_end: 'del app',
  },
  signInCode: {
    create_account_step_4_subtitle: 'Verifica tu correo electrónico',
  },
  success: {
    sign_in_success_title: '¡Cuenta registrada con éxito!',
    sign_in_success_description:
      'Ahora puedes iniciar sesión en tu cuenta y disfrutar de todos los servicios',
    sign_in_success_button: 'Ir a iniciar sesión',
    password_reset_success_title: '¡Contraseña cambiada con éxito!',
  },
  successView: {
    title: 'Account successfully created!',
    description: 'You can now log into your account and enjoy all the services',
    button_title: 'Go to Login',
  },
  home: {
    title_next_scheduling: 'Próximos Agendamientos',
    see_more: 'Ver Más',
    service_title: 'Servicios',
    empty_state_title: 'Ninguna consulta programada',
    empty_state_description:
      'Programa tu consulta y disfruta de una atención médica personalizada.',
    schedule_consultation: 'Agendar consulta',
    available_on: 'Disponible en',
    appstore: 'App Store',
    playstore: 'Play Store',
    qr_code_instruction: '¡Escanea el código QR para descargar la app!',
    title: '¡Accede a todo!',
    description:
      'Accede a más funcionalidades en la app! Descárgala para registrar dependientes, ver historial y más.',
  },
  appointmentDetails: {
    page_title: 'Próximas Citas',
    appoitment_title: 'Información de su Cita',
    appoitment_description: 'Resumen de la Cita',
    payment_title: 'Resumen del Pago',
    reschedule_appointment: 'Reprogramar Cita',
    cancel_appointment: 'Cancelar Cita',
    local_payment: 'Pago Local',
    total_value: 'Valor Total',
    back_to_home_btn: 'Volver',
    view_address: 'Ver Dirección',
    access_consultation: 'Acceder a la Consulta',
    cannot_cancel:
      '¡Ya no puedes reprogramar, tu cita está a punto de comenzar. Cancela sin reembolso.',
    you_can_cancel_or_reschedule_basic: 'Puedes cancelar o reprogramar',
    you_can_cancel_or_reschedule:
      'Puedes cancelar o reprogramar hasta {{date}}',
    cancellation_no_refund_reschedule_available:
      'Cancelación disponible sin reembolso. Puedes reprogramar sin costo hasta {{date}}',
    you_can_cancel_or_reschedule_with_refund:
      'Puede cancelar con reembolso o reprogramar su consulta',
    you_can_cancel_or_reschedule_no_refund:
      'Puede cancelar sin reembolso o reprogramar su consulta',
    online_consultation_available: 'Activo 15 min antes de la consulta',
  },
  banner: {
    banner_title: '¡Ten acceso a todo!',
    banner_description:
      '¡Accede a más funcionalidades en la app! Descárgala para registrar dependientes, ver historial y más.',
    banner_available_in_masc: 'Disponible en',
    banner_available_in_fem: 'Disponible en',
    banner_google_play: 'Google Play',
    banner_app_store: 'App Store',
    banner_scan_qr_code: '¡Escanea el código QR para descargar la app!',
  },

  schedule: {
    schedule_title: 'Nueva programación',
    schedule_choose_user_subtitle:
      '¡Empecemos!\nSeleccione para quién será el servicio',
    schedule_choose_appointment_type_title: 'Elige la mejor ubicación ',
    schedule_choose_appointment_in_person_location_title:
      'Elegir tipo de consulta',
    schedule_choose_appointment_type_online: 'Consulta en línea',
    schedule_choose_appointment_type_in_person: 'Consulta en persona',
    schedule_choose_doctor_title: 'Seleccione el médico que desea',
    screen_choose_doctor_no_prefence: 'No tengo preferencia',
    screen_choose_date_times_title: 'Horarios disponibles',
    screen_choose_date_no_time:
      'Todos los horarios para <bold>{{ date }}</bold> ya están reservados. Por favor, seleccione otro día para la cita.',
    screen_choose_payment_title: 'Seleccione método de pago',
    screen_choose_confirm_title: 'Consulta toda la información',
    screen_choose_payment_card: 'Tarjeta de crédito',
    screen_choose_pay_locally: 'Pagar localmente',
    screen_choose_pay_total_value: 'Valor total',
    screen_choose_before_confirm_appointment_subtitle:
      '¡antes de confirmar la cita!',
    screen_choose_confirm_schedule_title: 'Consulta toda la información',
    screen_choose_confirm_schedule_schedule_type: 'Tipo de servicio',
    screen_choose_confirm_schedule_patient: 'Paciente',
    screen_choose_confirm_schedule_doctor: 'Médico',
    screen_choose_confirm_schedule_date_time: 'Fecha y hora',
    screen_choose_confirm_schedule_time: 'Hora',
    screen_choose_confirm_schedule_payment_type: 'Método de pago',
    screen_choose_confirm_schedule_appointment_price: 'Valor de la consulta',
    screen_choose_confirm_schedule_discount_price: 'Descuento Medstation Card',
    screen_schedule_success:
      '¡Cita confirmada con éxito! Ahora puede consultar su información y gestionar sus citas de consulta.',
    screen_reschedule_success:
      '¡Cita cambiada con éxito! Ahora puede consultar su información y gestionar sus citas de consulta.',
    re_schedule_popup_title: '¿Reprogramar la cita?',
    re_schedule_popup_description:
      '¿No puedes llegar a tu cita? Reprograme ahora mismo.',
    screen_schedule_medstationcard_title: 'Conozca la Tarjeta Medstation',
    screen_schedule_medstationcard_text:
      'Consultas, procedimientos y exámenes con descuento',
    screen_schedule_confirm: 'Confirmar cita',
    screen_get_reschedule_error:
      'Error al reprogramar, por favor confirme el ID de la cita y vuelva a intentarlo.',
    schedule_no_locations_available:
      'No hay ubicaciones disponibles para la consulta en línea.',
    modal_error_payment_credit_card_title: '¡Vaya! Algo salió mal',
    modal_error_payment_credit_card_description:
      'Hubo un error al procesar su pago. Por favor, revise la información de su tarjeta.',
  },
  creditCard: {
    screen_credit_card_title: 'Tarjeta de crédito',
    screen_credit_card_subtitle:
      'Seleccione o registre una nueva tarjeta de crédito',
    screen_credit_card_register_new: 'Registrar nueva tarjeta',
    screen_credit_card_delete_popup_title: 'Deletar cartão?',
    screen_credit_card_delete_popup_description:
      'Si eliminas esta tarjeta, tendrás que volver a añadirla para utilizarla en el futuro. ¿Estás seguro de que quieres continuar?',
    screen_credit_card_empty_state_title: 'Registrar nueva tarjeta',
    screen_credit_card_empty_state_description:
      'No hay tarjetas registradas. Agregue una tarjeta para continuar con la cita.',
    screen_credit_card_register_title: 'Registrar nueva tarjeta de crédito',
    screen_credit_card_register_description:
      'Complete los datos de la tarjeta de crédito que desea registrar',
    screen_credit_card_register_number: 'Número de Tarjeta de Crédito',
    screen_credit_card_register_name: 'Nombre Impreso en la Tarjeta',
    screen_credit_card_register_date: 'Fecha de Expiración (MM/AA)',
    screen_credit_card_register_code: 'Código de Seguridad',
    screen_credit_card_register_number_btn:
      'Haz clic para completar el número de la tarjeta',
  },
  whatsAppPopup: {
    whatsAppPopup_title: '¿Consulta con seguro médico?',
    whatsAppPopup_description:
      'Agenda tu cita con el seguro de salud vía WhatsApp. Para pagos con tarjeta de crédito o Medstation Card, continúe aquí.',
    whatsAppPopup_stay_here: 'Continuar aquí',
    whatsAppPopup_go_to_whatsapp: 'Ir a Whatsapp',
  },
  popup: {
    reschedule_appointment: 'Reprogramar consulta',
    cancel_appointment: 'Cancelar consulta',
    shure_cancel_appointment: '¿Estás seguro de que deseas cancelar?',
    cancel_description:
      '¿No puedes asistir a tu consulta? En lugar de cancelarla, puedes reprogramarla ahora.',
  },
  privacyPolicy: {
    create_password: 'Crear contraseña',
    privacy_policy: 'Política de privacidad',
    how_we_use_and_store: 'Cómo usamos y almacenamos sus datos',
    last_updated: 'Última actualización el 16 de agosto de 2024',
    introduction: 'Introducción',
    welcome_message:
      'Bienvenido(a) a MedStation. La privacidad y seguridad de sus datos son nuestras mayores prioridades. Esta Política de Privacidad describe cómo recopilamos, usamos, compartimos y protegemos su información personal al utilizar nuestra aplicación. Estamos comprometidos a cumplir con todas las leyes y regulaciones aplicables, incluyendo la ',
    hipaa: 'Ley de Portabilidad y Responsabilidad del Seguro de Salud (HIPAA).',
    data_collection_title: 'Recolección de datos',
    data_collection_description: 'Qué datos recopilamos',
    data_use_title: 'Uso de datos',
    data_use_description: 'Cómo usamos sus datos',
    data_security_title: 'Seguridad de datos',
    data_security_description: 'Cómo protegemos sus datos',
  },
  dataCollection: {
    title: 'Política de Privacidad',
    section1_title: 'Recolección de datos',
    section1_subtitle: 'Qué datos recopilamos',
    section1_item1:
      '• Información personal: Nombre, fecha de nacimiento, información de contacto (correo electrónico, teléfono) y dirección.',
    section1_item2:
      '• Información de salud: Historial médico, condiciones de salud, recetas, historial de consultas.',
    section2_title: 'Cómo recopilamos',
    section2_item1:
      '• Directamente de usted durante el proceso de registro, al programar citas o interactuar con la aplicación.',
    section2_item2:
      '• Al registrar información de dependientes en la aplicación, usted declara que está autorizado para compartir estos datos y acepta en su nombre los términos de esta política.',
  },
  dataUse: {
    title: 'Política de Privacidad',
    section1_title: 'Uso de Datos',
    section1_subtitle: 'Por qué utilizamos sus datos',
    section1_item1:
      '• Para gestionar sus citas médicas y las de cualquier dependiente que registre.',
    section1_item2:
      '• Para proporcionar servicios de salud personalizados y eficientes.',
    section1_item3:
      '• Para enviar recordatorios y notificaciones relacionadas con su salud y citas.',
    section2_title: 'Compartición de datos',
    section2_item1:
      '• Con sus profesionales de salud: Para garantizar una atención coordinada y eficaz.',
    section2_item2:
      '• Con terceros de confianza: Solo con su consentimiento y cuando sea necesario, como laboratorios para pruebas o aseguradoras de salud.',
  },
  dataSecurity: {
    title: 'Política de privacidad',
    section_title: 'Seguridad de los datos',
    section_subtitle: 'Cómo protegemos tus datos',
    item1_description:
      '• Cumplimiento de HIPAA: Cumplimos estrictamente con todas las regulaciones de HIPAA que protegen la información de salud de los pacientes.',
    item2_description:
      '• Cifrado: Todos tus datos están cifrados tanto en tránsito como en reposo, lo que garantiza que tu información esté segura.',
    item3_description:
      '• Control de acceso: Solo el personal autorizado tiene acceso a tus datos, y solo para fines legítimos y específicos.',
    item4_description:
      '• Confidencialidad: Todos los datos que compartes con nosotros se tratan como información confidencial y están protegidos por medidas de seguridad estrictas. No divulgamos tu información personal sin tu consentimiento expreso, excepto para la prestación de servicios médicos o según lo exija la ley.',
  },
  appointment: {
    next_appointments: 'Próximas citas',
    all_appointments: 'Todas las citas',
    empty_filter:
      'No encontramos resultados con el filtro seleccionado. Intenta ajustar el filtro o restablecerlo para ver las citas.',
    load_more: 'Cargar más',
  },
  filter: {
    all_the_appointments: 'Todas las citas',
    only_my_appointments: 'Solo mis citas',
    only_my_dependents: 'Solo mis dependientes',
    apply: 'Aplicar',
    clear: 'Limpiar todo',
  },
  logout: {
    title: '¿Salir de su cuenta?',
    description:
      'Está a punto de desconectarse. ¿Está seguro de que desea salir?',
    lang_en: 'Inglés',
    lang_es: 'Español',
    lang_pt: 'Portugués',
    short_en: 'EN',
    short_es: 'ES',
    short_pt: 'PT',
  },
  deleteAccount: {
    delete_account_title: 'Eliminar Cuenta',
    title: 'Eliminar Cuenta en medstation',
    description: 'Cómo eliminar mi cuenta y toda mi información',
    section_title: 'Pasos',
    section_description: `\n•\tInicie sesión en la aplicación\n•\tEntre en su área de perfil (haga clic en su foto de perfil o donde están sus iniciales, en la esquina superior izquierda)\n•\tEn las opciones, seleccione 'Seguridad y Privacidad'\n•\tSeleccione 'Eliminar Cuenta'\n•\tLea y marque todas las opciones de confirmación de eliminación de sus datos, y haga clic en 'Eliminar Cuenta'\n•\tListo, ahora su cuenta ha sido eliminada completamente`,
  },
  termsOfUse: {
    create_password: 'Crear Contraseña',
    title: 'Términos de uso',
    description: 'Cómo utilizar nuestros servicios de manera adecuada',
    section_title: 'Introducción',
    section_description:
      'El uso de nuestros servicios está sujeto a los siguientes términos y condiciones, que describen las responsabilidades y obligaciones de los usuarios al utilizar la aplicación. Al aceptar estos Términos de Uso, usted declara que es consciente de que esta aceptación se aplica tanto a usted como a cualquier dependiente que registre en la aplicación, garantizando un uso adecuado y seguro de la plataforma.',
    top_button_title: 'Telemedicina',
    top_button_description: 'Cómo y cuándo usar el servicio',
    bottom_button_title: 'Política de cancelación',
    bottom_button_description: 'Cómo manejamos cancelaciones y reembolsos',
  },
  telemedicine: {
    title: 'Telemedicina',
    description: 'Cómo y cuándo usar el servicio',
    last_updated: 'Última actualización el 16 de agosto de 2024',
    presection_description:
      'Al utilizar nuestra aplicación para programar citas de telemedicina, usted consiente en los siguientes términos y condiciones:',
    section1: 'Modalidades de consulta',
    section1_description:
      '• Las consultas de telemedicina pueden realizarse mediante videollamada, llamada telefónica o chat de texto, según la disponibilidad y el acuerdo con el proveedor de atención médica.',
    section2: 'Limitaciones de la telemedicina',
    section2_description1:
      '• Usted reconoce que la telemedicina ofrece atención sin examen físico, por lo que no se recomienda para emergencias médicas. En caso de emergencia, debe llamar inmediatamente a los servicios de emergencia (como el 911).',
    section2_description2:
      '• Entiende que la programación de la consulta puede estar sujeta a retrasos o reprogramaciones debido a prioridades médicas más urgentes.',
    section3: 'Riesgos asociados a la telemedicina',
    section3_description1:
      '• Durante el uso de la telemedicina, pueden ocurrir fallos de comunicación entre usted y el proveedor de atención médica. Estos fallos pueden afectar la atención y el diagnóstico.',
    section3_description2:
      '• La telemedicina puede tener limitaciones, incluidas pero no limitadas a:',
    section3_description2_sub1:
      '• Restricciones o indisponibilidad de exámenes, recetas y otros registros médicos;',
    section3_description2_sub2:
      '• Dificultades del proveedor de atención médica para realizar una evaluación física detallada, lo que puede afectar el diagnóstico;',
    section3_description2_sub3:
      '• Retrasos en el diagnóstico o tratamiento debido a problemas técnicos, fallos de conexión o pérdida de datos.',
    section3_description3:
      '• Usted reconoce que estos factores pueden interferir en la atención y, por lo tanto, no responsabilizará a Medstation por posibles retrasos o pérdidas de información debido a fallos tecnológicos.',
    section4: 'Seguridad de datos',
    section4_description1:
      '• El uso de comunicación electrónica implica riesgos inherentes. A pesar de los esfuerzos por garantizar la seguridad, existe la posibilidad de que los datos digitales sean interceptados, modificados o accedidos por terceros.',
    section4_description2:
      '• Usted es responsable de utilizar una red segura al participar en una consulta de telemedicina.',
    section4_description3:
      '• Entiende que, incluso con medidas razonables para proteger la confidencialidad, las fallas técnicas pueden comprometer la transmisión de sus registros médicos.',
  },
  cancellationPolicy: {
    title: 'Política de cancelación',
    description: 'Cómo gestionamos cancelaciones y reembolsos',
    last_updated: 'Última actualización el 16 de agosto de 2024',
    presection_description:
      'Al utilizar nuestra aplicación para programar citas de telemedicina, usted consiente en los siguientes términos y condiciones:',
    section1: 'Cancelación con reembolso',
    section1_description:
      '• Las cancelaciones deben realizarse con al menos 24 horas de anticipación para garantizar el derecho a un reembolso.',
    section2: 'Reprogramación',
    section2_description:
      '• Las citas pueden reprogramarse sin costo hasta 3 horas antes. Después de este período, no se permitirá la reprogramación.',
    section3: 'Reembolso por tarjeta de crédito',
    section3_description:
      '• Los pagos realizados con tarjeta de crédito se reembolsarán conforme a las políticas del emisor de la tarjeta. El tiempo para el reembolso puede variar según la institución financiera.',
    section4: 'Cancelación de citas presenciales',
    section4_description1:
      '• Las citas presenciales pueden cancelarse o reprogramarse hasta 3 horas antes.',
    section4_description2:
      '• Si el pago ya se ha realizado mediante tarjeta de crédito, el monto se reembolsará según las políticas del emisor de la tarjeta. El tiempo para el reembolso puede variar según el operador financiero.',
    section5: 'Política de inasistencia',
    section5_description1:
      '• Si el paciente no asiste a la cita de telemedicina, nuestro equipo se comunicará dos veces por teléfono para intentar reprogramar la cita. Si no hay respuesta, no se otorgará un reembolso.',
    section5_description2:
      '• Si el paciente no asiste a la cita presencial, no se otorgará ningún reembolso, incluso si el pago ya se ha realizado.',
    bottom_description:
      'No se otorgarán reembolsos por cancelaciones relacionadas con cuestiones fuera de nuestro control, como problemas con farmacias o medicamentos.',
  },
};
